export default __webpack_public_path__ + "static/media/background_login.a2b0e5eb.png";